'use strict';

var chunkU3QCK4FI_js = require('./chunk-U3QCK4FI.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var u = require('react');
var B = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var u__default = /*#__PURE__*/_interopDefault(u);
var B__default = /*#__PURE__*/_interopDefault(B);

var S=B__default.default.a`
  color: ${({$color:t})=>t} !important;
  text-decoration: ${({$underLine:t})=>t?"underline":"none"};
  text-decoration-style: dashed;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({$gap:t})=>t};
  transition: transform 0.2s, filter 0.3s;

  &:active {
    transform: scale(0.98);
    filter: brightness(80%);
  }

  & p{
    font-size: ${({$fontSize:t})=>t};
    font-weight: ${({$fontWeight:t})=>t};
    line-height: ${({$lineHeight:t})=>t};
    border-bottom: ${({$border:t,$color:s})=>t?`1px dashed ${s}`:"none"};
    margin: 0;
    padding: 0;
  }

  &:hover {
    color: ${({$hoverColor:t})=>t} !important;
  }

  &.disabled {
    color: ${({$disabledColor:t})=>t} !important;
    cursor: not-allowed;
    pointer-events: none;
  }
`,x=({href:t="",prefixIcon:s,suffixIcon:m,label:c,target:g="_self",underLine:$=!0,variant:e="ghost",size:i="medium",disabled:p=!1,onClick:o,preventDefaultBehaviour:h=!1,asLink:l=!0,border:y=!1})=>{let{tokens:L}=chunkHUKGHOBJ_js.b(),{variants:n,sizes:a}=chunkU3QCK4FI_js.a(L),T=async r=>{if(p){r.preventDefault(),r.stopPropagation();return}h&&r.preventDefault(),o&&(o==null||o(r));};return u__default.default.createElement(S,{as:l?"a":"span",href:l?t:void 0,target:l?g:void 0,$color:n[e].color,$hoverColor:n[e].hoverColor,$disabledColor:n[e].disabledColor,$underLine:$,$fontSize:a[i].fontSize,$fontWeight:a[i].fontWeight,$lineHeight:a[i].lineHeight,$gap:n[e].gap,$border:y,className:`${p?"disabled":""}`,onClick:T},s||null,u__default.default.createElement("p",null,c),m||null)};

exports.a = x;
